import { __assign, __extends } from "tslib";
import { throttle, uniq, isEqual } from '@antv/util';
import { VIEW_LIFE_CIRCLE } from '../dependents';
import BaseInteraction from './base';
import BBox from '../util/bbox';
import TimeLine from '../components/timeline';
var DEFAULT_HEIGHT = 40;
function getValidTimeLineConfig(interaction) {
    return __assign({ loop: false, auto: true, height: DEFAULT_HEIGHT, padding: [0, 20, 0, 0], speed: 2 }, interaction);
}
var TimeLineInteraction = /** @class */ (function (_super) {
    __extends(TimeLineInteraction, _super);
    function TimeLineInteraction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeFn = throttle(_this.onChange.bind(_this), 20, { leading: true });
        return _this;
    }
    /** TimeLineInteraction new 时的范围参数 interactionRange */
    TimeLineInteraction.getInteractionRange = function (layerRange, interaction) {
        var config = getValidTimeLineConfig(interaction);
        var paddingTop = config.padding[0];
        var paddingBottom = config.padding[2];
        return new BBox(layerRange.minX, layerRange.maxY - config.height - paddingTop - paddingBottom, layerRange.width, config.height + paddingTop + paddingBottom);
    };
    TimeLineInteraction.prototype.setAnimate = function (isAnimate) {
        var geometries = this.view.geometries;
        this.view.animate(isAnimate);
        geometries.forEach(function (geom) {
            geom.animate(isAnimate);
        });
    };
    TimeLineInteraction.prototype.start = function () {
        return;
    };
    TimeLineInteraction.prototype.renderTimeLine = function () {
        var _this = this;
        this.config = getValidTimeLineConfig(this.getInteractionConfig());
        var viewRange = this.view.viewBBox;
        var _a = this.config, loop = _a.loop, padding = _a.padding, speed = _a.speed;
        var paddingTop = padding[0], paddingRight = padding[1], paddingBottom = padding[2], paddingLeft = padding[3];
        var range = this.getRange();
        var ticks = this.getTicks();
        var width = viewRange.width - paddingLeft - paddingRight;
        var timeLineConfig = {
            x: viewRange.minX + paddingLeft,
            y: range.tl.y + paddingTop,
            width: width,
            height: range.height - paddingTop - paddingBottom,
            loop: loop,
            ticks: ticks,
            speed: speed,
            defaultCurrentTick: ticks[0],
        };
        if (this.timeline) {
            if (!isEqual(timeLineConfig, this.timeLineConfig)) {
                this.timeLineConfig = timeLineConfig;
                this.timeline.update(timeLineConfig);
            }
        }
        else {
            this.container = this.canvas.addGroup();
            this.timeline = new TimeLine(__assign({ container: this.container }, timeLineConfig));
            this.timeline.init();
            this.timeline.render();
            this.timeline.on('timelinestart', function () {
                _this.originAnimation = _this.view.getOptions().animate;
                _this.setAnimate(true);
            });
            this.timeline.on('timelineend', function () {
                _this.setAnimate(_this.originAnimation);
            });
            this.timeline.on('timelinechange', this.onChangeFn);
            this.timeline.on('timelineupdate', this.onChange.bind(this));
            this.view.data(this.getFilterData(ticks[0]));
            this.timeLineConfig = timeLineConfig;
        }
    };
    TimeLineInteraction.prototype.onChange = function (tick) {
        var filterData = this.getFilterData(tick);
        this.view.changeData(filterData);
    };
    TimeLineInteraction.prototype.getFilterData = function (tick) {
        var field = this.config.field;
        var data = this.getViewLayer().options.data;
        return data.filter(function (item) { return item[field] === tick; });
    };
    TimeLineInteraction.prototype.getTicks = function () {
        var field = this.config.field;
        var data = this.getViewLayer().options.data;
        return uniq(data.map(function (item) { return item[field]; }));
    };
    /** 渲染 timeline */
    TimeLineInteraction.prototype.render = function () {
        var _this = this;
        this.firstRender = true;
        this.view.on(VIEW_LIFE_CIRCLE.BEFORE_RENDER, function () {
            _this.renderTimeLine();
        });
        this.view.on(VIEW_LIFE_CIRCLE.BEFORE_PAINT, function () {
            _this.renderTimeLine();
        });
        this.view.on(VIEW_LIFE_CIRCLE.AFTER_PAINT, function () {
            if (_this.config.auto && _this.firstRender) {
                _this.timeline.isPlay = true;
                _this.timeline.changePlayStatus();
            }
            _this.firstRender = false;
        });
        this.view.on(VIEW_LIFE_CIRCLE.AFTER_RENDER, function () {
            if (_this.config.auto && _this.firstRender) {
                _this.timeline.isPlay = true;
                _this.timeline.changePlayStatus();
            }
            _this.firstRender = false;
        });
    };
    TimeLineInteraction.prototype.clear = function () {
        if (this.timeline) {
            this.timeline.destroy();
            this.timeline = null;
        }
        if (this.container) {
            this.container.remove(true);
            this.container = null;
        }
    };
    return TimeLineInteraction;
}(BaseInteraction));
export default TimeLineInteraction;
//# sourceMappingURL=timeline.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/interaction/timeline.js
// module id = null
// module chunks = 